export default class Organization {
    id: number;
    code: string;
    displayName: string;
}